<template>
  <div class="global-watermark-wrapper" style="display: none;"></div>
</template>

<script>
import { setWatermark, removeWatermark } from '@/utils/watermark.js';
import { mapState } from 'vuex';

export default {
  name: 'GlobalWatermark',
  data() {
    return {
      resizeTimer: null
    }
  },
  computed: {
    // 从 Vuex 动态获取用户名
    ...mapState('d2admin', {
      username: state => state.user.info.username
    }),
  },
  watch: {
    // 核心修复：监听用户名变化（解决异步加载和登出置空问题）
    username(newVal) {
      // 无论 newVal 是拿到真实名字，还是登出后变成 null/undefined/''，都触发重绘
      this.refreshWatermark();
    }
  },
  mounted() {
    // 首次挂载初始化
    this.refreshWatermark();
    // 监听窗口缩放防抖重绘
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    refreshWatermark() {
      const now = new Date();
      const time = this.formatDate(now);

      // 处理登出或未加载时的状态：如果没有值，则展示为空字符串
      const currentUserName = this.username || '';

      // 传入 Canvas 进行绘制
      setWatermark([currentUserName, time]);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.refreshWatermark();
      }, 200);
    }
  },
  destroyed() {
    // 组件卸载时，严格清理监听器和水印节点，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
    removeWatermark();
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/GlobalWatermark/index.vue"
}
</vue-filename-injector>
